export default {
  'Difficulty level': 'Nível de dificuldade',
  'Your bet': 'Aposta',
  'Start game': 'Toque',
  'Take prize': 'Levar',
  'Try again': 'Tente novamente',
  Bet: 'Aposta',
  Profit: 'Lucro',
};
